export var WalletName;
(function (WalletName) {
    WalletName["NeoLine"] = "NeoLine";
    WalletName["O3"] = "O3";
    WalletName["WalletConnect"] = "WalletConnect";
    WalletName["Neon"] = "Neon";
    WalletName["OneGate"] = "OneGate";
})(WalletName || (WalletName = {}));
//# sourceMappingURL=types.js.map